/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetStatsByDriversQueryResponse, GetStatsByDriversQueryParams, GetStatsByDrivers400 } from '../entities/GetStatsByDrivers'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetStatsByDriversUrl() {
  return `/stats/by-drivers` as const
}

/**
 * @description Get stats by drivers
 * @summary Get stats by drivers
 * {@link /stats/by-drivers}
 */
export async function getStatsByDrivers(params: GetStatsByDriversQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetStatsByDriversQueryResponse, ResponseErrorConfig<GetStatsByDrivers400>, unknown>({
    method: 'GET',
    url: getGetStatsByDriversUrl().toString(),
    params,
    ...requestConfig,
  })
  return res.data
}